export default __webpack_public_path__ + "static/media/bee_path.2ee69692.svg";